module.exports = __webpack_public_path__ + "img/img_detention_top.a93fdfbe.png";